/** Step 3b — 自定义活动图标 */
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSettings } from '../../components/providers/AppSettingsProvider';
import { loadAuthUser } from '../../services/auth';
import { createPageUrl } from '../../utils';
import { CheckInShell } from './components/CheckInShell';
import { CUSTOM_ACTIVITY_ICON_CHOICES } from './data/activityIcons';
import { addCustomEventToStorage } from './hooks/useCustomEvents';

const iconTileClass =
  'flex aspect-square w-full flex-col items-center justify-center rounded-2xl border border-white/35 bg-white/[0.12] text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.22)] backdrop-blur-xl backdrop-saturate-150 transition-transform active:scale-[0.98]';

type LocationState = { moodTag?: string; customTitle?: string };

const CheckInEventCustomizeIcon: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useAppSettings();
  const { moodTag, customTitle } = (location.state as LocationState | null) ?? {};
  const [selectedId, setSelectedId] = useState<string | null>(null);

  useEffect(() => {
    if (!loadAuthUser()) {
      navigate('/splash', { replace: true, state: { forceLogin: true } });
    }
  }, [navigate]);

  useEffect(() => {
    if (!moodTag || !customTitle) {
      if (moodTag) {
        navigate(createPageUrl('CheckInEventCustomize'), { replace: true, state: { moodTag } });
      } else {
        navigate('/check-in', { replace: true });
      }
    }
  }, [moodTag, customTitle, navigate]);

  if (!moodTag || !customTitle) return null;

  const handleContinue = () => {
    if (!moodTag || !customTitle || !selectedId) return;
    const choice = CUSTOM_ACTIVITY_ICON_CHOICES.find((c) => c.id === selectedId);
    if (!choice) return;
    addCustomEventToStorage(customTitle, choice.emoji, choice.id);
    navigate(createPageUrl('CheckInSummary'), {
      state: { moodTag, activityTag: customTitle, activityEmoji: choice.emoji },
    });
  };

  return (
    <CheckInShell
      ctaLabel={t('checkIn.continue')}
      onCta={handleContinue}
      ctaDisabled={!selectedId}
    >
      <p className="mt-6 px-1 text-center text-base font-normal leading-snug text-white/90">
        {t('checkIn.customIconTitle', { name: customTitle })}
      </p>

      <div
        className="mt-8 grid w-full max-w-[20rem] grid-cols-5 gap-2.5 sm:max-w-[22rem] sm:gap-3"
        role="list"
        aria-label={t('checkIn.customIconPicker')}
      >
        {CUSTOM_ACTIVITY_ICON_CHOICES.map(({ id, Icon }) => {
          const on = selectedId === id;
          return (
            <button
              key={id}
              type="button"
              role="listitem"
              onClick={() => setSelectedId(id)}
              className={`${iconTileClass} ${
                on
                  ? 'scale-[1.04] ring-2 ring-white/90 ring-offset-2 ring-offset-[#0a1224]'
                  : 'opacity-[0.97] hover:opacity-100'
              }`}
            >
              <Icon className="h-7 w-7 shrink-0 opacity-95" strokeWidth={1.75} aria-hidden />
            </button>
          );
        })}
      </div>
    </CheckInShell>
  );
};

export default CheckInEventCustomizeIcon;
